import { RefObject, useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideClick = (
  refs: RefObject<HTMLDivElement | null>[] = [],
  callback: () => void,
) => {
  useEffect(() => {
    function handleClickOutside(event: Event) {
      const target = event.target as Node;
      const clickedOnRef = refs
        .map((ref) => ref.current && ref.current.contains(target))
        .includes(true);
      if (target && !clickedOnRef) {
        callback?.();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs]);
};
